/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BulkUpdateAlertDefinitionsSensitivityLevelMutationVariables = GraphQL.Exact<{
  alertDefinitionIds: ReadonlyArray<GraphQL.Scalars['AlertDefinitionId']['input']> | GraphQL.Scalars['AlertDefinitionId']['input'];
  sensitivityLevel: GraphQL.AlertSensitivityLevel;
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type BulkUpdateAlertDefinitionsSensitivityLevelMutation = { readonly __typename?: 'Mutation', readonly BulkUpdateAlertDefinitionsSensitivityLevel: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly alertDefinitions: ReadonlyArray<{ readonly __typename?: 'AlertDefinition', readonly alertType: string, readonly id: CK.AlertDefinitionId, readonly recipients: ReadonlyArray<string>, readonly scope: string, readonly settings: Record<string, any>, readonly messagingAppChannels: ReadonlyArray<{ readonly __typename?: 'MessagingAppChannel', readonly id: CK.ID, readonly label: string, readonly messagingAppType: GraphQL.MessagingAppType }> }> } | null } } };


export const BulkUpdateAlertDefinitionsSensitivityLevelDocument = gql`
    mutation BulkUpdateAlertDefinitionsSensitivityLevel($alertDefinitionIds: [AlertDefinitionId!]!, $sensitivityLevel: AlertSensitivityLevel!, $websiteId: WebsiteId!) {
  BulkUpdateAlertDefinitionsSensitivityLevel(
    alertDefinitionIds: $alertDefinitionIds
    sensitivityLevel: $sensitivityLevel
    websiteId: $websiteId
  ) {
    query {
      website(id: $websiteId) {
        alertDefinitions {
          alertType
          id
          messagingAppChannels {
            id
            label
            messagingAppType
          }
          recipients
          scope
          settings
        }
        id
      }
    }
  }
}
    `;
export type BulkUpdateAlertDefinitionsSensitivityLevelMutationFn = Apollo.MutationFunction<BulkUpdateAlertDefinitionsSensitivityLevelMutation, BulkUpdateAlertDefinitionsSensitivityLevelMutationVariables>;

/**
 * __useBulkUpdateAlertDefinitionsSensitivityLevelMutation__
 *
 * To run a mutation, you first call `useBulkUpdateAlertDefinitionsSensitivityLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateAlertDefinitionsSensitivityLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateAlertDefinitionsSensitivityLevelMutation, { data, loading, error }] = useBulkUpdateAlertDefinitionsSensitivityLevelMutation({
 *   variables: {
 *      alertDefinitionIds: // value for 'alertDefinitionIds'
 *      sensitivityLevel: // value for 'sensitivityLevel'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useBulkUpdateAlertDefinitionsSensitivityLevelMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateAlertDefinitionsSensitivityLevelMutation, BulkUpdateAlertDefinitionsSensitivityLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateAlertDefinitionsSensitivityLevelMutation, BulkUpdateAlertDefinitionsSensitivityLevelMutationVariables>(BulkUpdateAlertDefinitionsSensitivityLevelDocument, options);
      }
export type BulkUpdateAlertDefinitionsSensitivityLevelMutationHookResult = ReturnType<typeof useBulkUpdateAlertDefinitionsSensitivityLevelMutation>;
export type BulkUpdateAlertDefinitionsSensitivityLevelMutationResult = Apollo.MutationResult<BulkUpdateAlertDefinitionsSensitivityLevelMutation>;
export type BulkUpdateAlertDefinitionsSensitivityLevelMutationOptions = Apollo.BaseMutationOptions<BulkUpdateAlertDefinitionsSensitivityLevelMutation, BulkUpdateAlertDefinitionsSensitivityLevelMutationVariables>;